export default __webpack_public_path__ + "static/media/casa.badcb5aa.png";